<div class="order-counter"
(click)="refreshOrders()"
>
  <i class="material-icons" title="Новые заказы">notifications</i>
  <div class="new-orders" *ngIf="ordersCounter > 0">+{{ordersCounter}}</div>
</div>
